import { GeneralAvailabilityDay } from '../types';

export const defaultAvailability: GeneralAvailabilityDay[] = [
  {
    dayOfWeekId: 1,
    labelKey: 'components.generalAvailability.labelSunday',
    timeEarly: true,
    timeMorning: true,
    timeAfternoon: true,
    timeEvening: true,
    timeOvernight: true,
    timeNever: false,
  },
  {
    dayOfWeekId: 2,
    labelKey: 'components.generalAvailability.labelMonday',
    timeEarly: true,
    timeMorning: true,
    timeAfternoon: true,
    timeEvening: true,
    timeOvernight: true,
    timeNever: false,
  },
  {
    dayOfWeekId: 3,
    labelKey: 'components.generalAvailability.labelTuesday',
    timeEarly: true,
    timeMorning: true,
    timeAfternoon: true,
    timeEvening: true,
    timeOvernight: true,
    timeNever: false,
  },
  {
    dayOfWeekId: 4,
    labelKey: 'components.generalAvailability.labelWednesday',
    timeEarly: true,
    timeMorning: true,
    timeAfternoon: true,
    timeEvening: true,
    timeOvernight: true,
    timeNever: false,
  },
  {
    dayOfWeekId: 5,
    labelKey: 'components.generalAvailability.labelThursday',
    timeEarly: true,
    timeMorning: true,
    timeAfternoon: true,
    timeEvening: true,
    timeOvernight: true,
    timeNever: false,
  },
  {
    dayOfWeekId: 6,
    labelKey: 'components.generalAvailability.labelFriday',
    timeEarly: true,
    timeMorning: true,
    timeAfternoon: true,
    timeEvening: true,
    timeOvernight: true,
    timeNever: false,
  },
  {
    dayOfWeekId: 7,
    labelKey: 'components.generalAvailability.labelSaturday',
    timeEarly: true,
    timeMorning: true,
    timeAfternoon: true,
    timeEvening: true,
    timeOvernight: true,
    timeNever: false,
  },
];
